import "./Header.css";

const Header = () => {
  return (
    <div className="header">
      <div className="title">Story</div>
      <ul className="nav">
        <li>Shop</li>
        <li>Menu</li>
      </ul>
    </div>
  );
};

export default Header;
